import { UserProps, UsersProps } from "admin/ui";
import { useCourse, useUser} from "hooks";
import { useNotification } from "providers";
import { useProfileStore } from "store";
import { IUser, IUserStatusCounts } from "utils/types";

export const useUserFlow = ():
Pick<UsersProps, "onGetUsers" | "onGetUsersStat" >  & 
Pick<UserProps, "onChangeUserStatus"|"onGetUser"|"onGetUserCourses">  & {
    onGetAdminUsersStat: () => Promise<IUserStatusCounts|undefined>;
    onDeleteUser: (userId: string) => Promise<string|undefined>;
    onUpdateUser: (user: Partial<IUser>) => Promise<IUser|undefined>;
}=> {
    const userHook = useUser();
    const courseHook = useCourse();
    const { success, error } = useNotification();
    const { user } = useProfileStore();
    return {
        async onUpdateUser(data) {
            if(!user?.id){
                error({ message: "user data not found, make sure you are logged in."})
            }
            const res = await userHook.updateUser({
                userId: user?.id!, 
                user: data
            })
            if(res){
                success({ message: "Profile updated!"})
            }
            return res;
        },
        async onDeleteUser(userId) {
            const res = await userHook.deleteUser({ userId })
            if(res){
                success({
                    message: "User deleted successfully"
                })
            }
            return res
        },
        async onGetUser(userId) {
            return userHook.getUser({ user: { id: userId }})
        },
        async onGetUserCourses(userCourse) {
            return (await courseHook.getUserCourses(userCourse)) || []
        },
        async onGetUsersStat() {
            const res = await userHook.getUserStatusStats();
            return res?.userStatusCounts
        },
        async onGetAdminUsersStat() {
            const res = await userHook.getAdminUserStatusStats();
            return res?.userStatusCounts
        },
        async onChangeUserStatus(userId, status) {
            const res = await userHook.updateUser({
                userId, user: {
                    userStatus: status
                }
            })

            if(res){
                success({
                    message: "User status changed successfully"
                })
            }
            return res
        },
        async onGetUsers(data) {
            const res = await userHook.getUsers(data)
            return {
                data: res?.users || [],
                total: res?.total || 0
            }
        },
    }
};